import React, { useState } from 'react';
import { Field, Formik } from 'formik';
import Fields from 'components/Fields';
import api from 'api';
import { Button } from 'components/Base';
import * as Yup from 'yup';
import { Notify } from 'utils';

interface ProviderInformationProps {
  data: any;
  updateData: Function;
  classes: any;
}

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  website: Yup.string().url('Invalid URL').nullable(),
  logo: Yup.mixed().nullable(),
  contact_number: Yup.string().nullable(),
  email: Yup.string().email('Invalid email').nullable()
});

const ProviderInformation = ({
  data,
  updateData,
  classes
}: ProviderInformationProps) => {
  const [isSaving, setIsSaving] = useState(false);

  return (
    <Formik
      enableReinitialize
      initialValues={
        {
          name: data.name,
          website: data.website,
          logo: null,
          contact_number: data.contact_number,
          email: data.email
        } as any
      }
      onSubmit={values => {
        setIsSaving(true);

        if (values.logo === null) {
          delete values.logo;
        }

        const formData = new FormData();
        for (const key in values) {
          formData.append(key, values[key]);
        }

        api
          .updateMpsProvider(data.id, formData)
          .then(({ data }) => {
            updateData(data);
            Notify.success('Provider information updated successfully.');
          })
          .catch(() => {
            Notify.error('Provider information could not be updated.');
          })
          .finally(() => {
            setIsSaving(false);
          });
      }}
      validationSchema={validationSchema}
    >
      {({ handleSubmit }) => {
        return (
          <form onSubmit={handleSubmit}>
            <div>
              <div className={classes.row}>
                <div className={classes.label}>Provider name</div>
                <div className={classes.fieldWrapper}>
                  <Field name="name" component={Fields.v2.Text} filled />
                </div>
              </div>
              <div className={classes.row}>
                <div className={classes.label}>Website</div>
                <div className={classes.fieldWrapper}>
                  <Field name="website" component={Fields.v2.Text} filled />
                </div>
              </div>
              <div className={`${classes.row} ${classes.alignStart}`}>
                <div className={classes.label}>Company logo</div>
                <div className={classes.fieldWrapper}>
                  <Field
                    name="logo"
                    component={Fields.v2.FileUpload}
                    accept="image/*"
                    url={data.logo_url}
                  />
                </div>
              </div>
              <div className={classes.row}>
                <div className={classes.title}>
                  For sales and general enquiries
                </div>
              </div>
              <div className={classes.row}>
                <div className={classes.label}>Contact number</div>
                <div className={classes.fieldWrapper}>
                  <Field
                    name="contact_number"
                    component={Fields.v2.Text}
                    filled
                  />
                </div>
              </div>
              <div className={classes.row}>
                <div className={classes.label}>Email address</div>
                <div className={classes.fieldWrapper}>
                  <Field name="email" component={Fields.v2.Text} filled />
                </div>
              </div>
            </div>
            <div>
              <Button type="submit" disabled={isSaving} isLoading={isSaving}>
                Save
              </Button>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};

export default ProviderInformation;
